// This file is generated automatically by scripts/generate-flag.js. Don't modify it.
import React from 'react';
import AlandIslands from '../_raw/flag/icon_flag_aland_islands.png';

export default () => <img src={AlandIslands} alt="AlandIslands" />;
